import React from 'react'

const OPTIONS = [
  { value: 'NEW', label: '최초청구' },
  { value: 'ADDITIONAL', label: '동일사고 추가접수' },
]

/**
 * 보험금 청구 접수 구분: 최초청구(NEW) vs 동일사고 추가접수(ADDITIONAL).
 * extraFields.accidentReceiptType 과 동일 값을 사용합니다.
 */
export default function ClaimReceiptTypePick({ value, onChange, disabled, idPrefix = 'claim-receipt' }) {
  return (
    <div className="flex flex-wrap gap-3" role="group" aria-label="접수 구분">
      {OPTIONS.map((opt) => {
        const selected = value === opt.value
        const baseId = `${idPrefix}-${opt.value}`
        return (
          <button
            key={opt.value}
            id={baseId}
            type="button"
            disabled={disabled}
            onClick={() => onChange(opt.value)}
            className={`inline-flex min-w-[10rem] max-w-full items-center gap-3 rounded-lg border-2 px-4 py-3 text-left text-sm font-medium transition-colors ${
              selected
                ? 'border-brand-navy bg-sky-50 text-brand-navy shadow-sm ring-1 ring-brand-navy/10'
                : 'border-slate-200 bg-white text-slate-800 hover:border-slate-400 hover:bg-slate-50'
            } disabled:cursor-not-allowed disabled:opacity-50`}
          >
            <span
              className={`flex h-6 w-6 shrink-0 items-center justify-center rounded border-2 text-sm font-bold leading-none ${
                selected ? 'border-brand-navy bg-white text-brand-navy' : 'border-slate-300 bg-white text-transparent'
              }`}
              aria-hidden
            >
              {selected ? '✓' : '\u00a0'}
            </span>
            <span>{opt.label}</span>
          </button>
        )
      })}
    </div>
  )
}
